export default [
  {
    path: "reCommodity",
    name: "ReCommodity",
    component: () => import("../pages/reCommodity/reCommodity.vue"),
    meta: {
      title: "回货报表",
    },
  },

  {
    path: "reportDetail/:supply_id/:date",
    name: "CommodityReportDetail",
    component: () => import("../pages/reCommodity/detail.vue"),
    meta: {
      title: "回货报表详情",
    },
  },

  // 坏账盘盈日报表
  {
    path: "SurplusBrokenDebtDayReport",
    name: "SurplusBrokenDebtDayReport",
    component: () => import("../pages/SurplusBrokenDebtDayReport.vue"),
    meta: {
      title: "坏账盘盈报表",
    },
  },

  // 重采计划日志
  {
    path: "reCgPlanLog",
    name: "ReCgPlanLog",
    component: () => import("../pages/reCgPlanLog.vue"),
    meta: {
      title: "重采计划日志",
    },
  },
];
// reCommodityRouter;



// WEBPACK FOOTER //
// ./src/router/reCommodityRouter.js